import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { GridConfiguration } from '../../../types/grid-configuration.type';
import { LotAddPhotoImagesSorterComponent } from '../../images-sorter/lot-add-photo-images-sorter/lot-add-photo-images-sorter.component';

@Component({
  selector: 'app-lot-add-photo-modal-sort-view',
  templateUrl: './lot-add-photo-modal-sort-view.component.html',
  styleUrls: ['./lot-add-photo-modal-sort-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoModalSortViewComponent implements OnInit {
  @Input() initialImages: string[] = [];
  @Input() noAuctionList = false;
  @Input() grid: GridConfiguration;
  @Input() itemHeightPx: number;
  @Output() completed = new EventEmitter<string[]>();

  images: string[] = [];

  hasSelected = false;

  @ViewChild('sorter')
  sorter: LotAddPhotoImagesSorterComponent;

  ngOnInit(): void {
    this.images = this.initialImages;
  }

  complete(): void {
    this.completed.emit(this.images);
  }

  cancel(): void {
    this.completed.emit(this.initialImages);
  }

  resetSelected(): void {
    this.sorter.resetSelected();
  }
}
